export const JOB_STATE = {
    PROCESSING: 'processing',
    SUCCEEDED: 'succeeded',
    FAILED: 'failed',
    CANCELED: 'canceled',
    TIMEOUT: 'timeout',
    PENDING: 'pending',
    DELETED: 'deleted',
};
export const JOB_ERROR_CODE = {
    MEDIA_PREPROCESSING_FAILED: 'MEDIA_PREPROCESSING_FAILED',
    TRANSCRIPTION_FAILED: 'TRANSCRIPTION_FAILED',
    NO_TRANSCRIPTION: 'NO_TRANSCRIPTION',
    HIGHLIGHT_DETECTION_FAILED: 'HIGHLIGHT_DETECTION_FAILED',
    NO_HIGHLIGHTS_DETECTED: 'NO_HIGHLIGHTS_DETECTED',
    UNKNOWN: 'UNKNOWN',
    UPLOAD_ERROR: 'UPLOAD_ERROR',
};

export const GENERATE_STATE = {
    PROCESSING: 'processing',
    SUCCEEDED: 'succeeded',
    FAILED: 'failed',
    PENDING: 'pending',
};

export const PROCESS_TYPE = {
    UPLOAD_VIDEO: 'UPLOAD_VIDEO',
    UPLOAD_AUDIO: 'UPLOAD_AUDIO',
    BACKEND: 'BACKEND',
    FACE_DETECT: 'FACE_DETECT',
    COVER_THUMBNAILS: 'COVER_THUMBNAILS',
    EXPORT: 'EXPORT',
};
